import { ThemeUICSSObject } from 'theme-ui';

export const datePicker: ThemeUICSSObject = {
  maxWidth: '400px',
};
